import api from "../../axiosconfig";

export async function submitCheckin(payload) {
  const { data } = await api.post("/api/checkins", payload);
  return data;
}

export async function getTodayCheckinStatus(date) {
  const { data } = await api.get("/api/checkins/today", {
    params: { date },
  });
  return data;
}

export async function getCompanyCheckinAnalytics(params) {
  const { start_date, end_date } = params;
  const { data } = await api.get("/api/admin/company-checkins", {
    params: {
      start_date,
      end_date,
    },
  });
  return data;
}

export async function getCompanyDomainCounts(params) {
  const { start_date, end_date } = params;
  const { data } = await api.get("/api/admin/checkins/domain-counts", {
    params: {
      start_date,
      end_date,
    },
  });
  return data;
}

export async function getWellnessTimeseries(params = {}) {
  const {
    mode = "weekly",
    buckets = 4,
    end_date,
  } = params;

  const { data } = await api.get("/api/checkins/wellness-timeseries", {
    params: {
      mode,
      buckets,
      end_date,
    },
  });

  return data;
}

export async function getCompanyWellnessTimeseries(params = {}) {
  const { mode = "weekly", buckets = 4, end_date } = params;
  const { data } = await api.get("/api/admin/checkins/aggregated-averages-series", {
    params: { mode, buckets, end_date },
  });
  return data;
}
